// CommitmentCard.tsx

import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

type CommitmentCardProps = {
  text: string; // The mission statement text (HTML string with highlighted phrases)
};

/* Style for the card container */
const CardContainer = styled.div`
  position: relative;
  background: linear-gradient(135deg, rgba(1, 65, 1, 0.9) 0%, rgba(255, 255, 255, 0.9) 4%);
  border-radius: 8px;
  margin-bottom: 1rem;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: box-shadow 0.3s ease, transform 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  }

  /* Add a green triangle on the top left corner */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-left: 20px solid green;
    border-bottom: 20px solid transparent;
  }
`;

const CommitmentCard: React.FC<CommitmentCardProps> = ({ text }) => {
  return (
    // Wrap the entire card in a motion.div for a fade-in effect.
    <motion.div
      // "initial" is the starting animation state (completely hidden, slightly moved down).
      initial={{ opacity: 0, y: 20 }}
      // "whileInView" triggers when the component scrolls into view.
      whileInView={{ opacity: 1, y: 0 }}
      // "viewport" options: only animate once, and consider 20% of the component's visibility as the trigger.
      viewport={{ once: true, amount: 0.2 }}
      // "transition" controls speed/easing.
      transition={{ duration: 0.5 }}
    >
      <CardContainer>
        {/* dangerouslySetInnerHTML is needed because text is an HTML string with <span> tags */}
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </CardContainer>
    </motion.div>
  );
};

export default CommitmentCard;
